<template>
  <div>
    <div class="vx-col w-full mb-base">
      <vs-card title="Add New Customer" class="p-4 mb-6">
        <div slot="header" class="flex flex-wrap items-center justify-between">
          <div class="flex items-center">
            <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
            <h4 style="margin-left: 10px">Change Password</h4>
          </div>
          <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm" :disabled="isForm == true ? false : true">Save</vs-button>
        </div>
        <div class="vx-row mt-6">
          <div class="vx-col md:w-1/4 w-full">
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-input class="w-full" type="password" label="Current password *" v-model="current_password" v-on:keyup="checkForm"/>
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-input class="w-full" type="password" label="New password *" v-model="new_password" v-on:keyup="checkForm"/>
              </div>
            </div>

            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-input class="w-full" type="password" label="Retype new password *" v-model="re_password" v-on:keyup="checkForm"/>
              </div>
            </div>

          </div>
        </div>
      </vs-card>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  components: {
    vSelect,
    flatPickr
  },
  data() {
    return {
      isLoading: false,
      current_password: "",
      new_password: "",
      re_password: "",
      isForm: false,
    };
  },
  watch: {
    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    }
  },
  methods: {
    submitForm() {
      this.isLoading = true;
      this.$http.post("rolemanagement/users/change_password", {
          current_password: this.current_password,
          new_password: this.new_password,
          re_password: this.re_password
      })
      .then(res => {
          this.isLoading = false;
          const message = res.data.message ? res.data.message : 'Success.'
          this.$vs.notify({
              color: "success",
              title: "Success",
              iconPack: "feather",
              icon: "icon-check",
              text: message
          });
          
          this.$router.push({
              name: "dashboard"
          });
      })
      .catch(error => this.handleError(error));  
    },
    checkForm(){
      if(this.current_password.length > 2){
        if(this.new_password.length > 2){
          if(this.new_password == this.re_password){
            this.isForm = true
          }
        }
      }
    },
    back() {
      if (
        this.current_password != "" ||
        this.new_password != "" ||
        this.re_password != ""
      ) {
        this.$vs.dialog({
          color: "warning",
          title: "Leave Page",
          text: "Changes you made may not be saved?",
          acceptText: "Leave Page",
          accept: () => this.$router.go(-1)
        });
      } else {
        this.$router.go(-1);
      }
    },
  },
  mounted() {
  }
};
</script>